module.exports = __webpack_public_path__ + "img/footer_img.8bc872c6.svg";